import { render, staticRenderFns } from "./BooleanCheckboxInput.vue?vue&type=template&id=ef0835d2&"
import script from "./BooleanCheckboxInput.vue?vue&type=script&lang=js&"
export * from "./BooleanCheckboxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports